<!--Title-->
<h3>{{'_General_Kiosks_Text_' | translate }}</h3>

<div class="cc-content-wrapper">
  <!--Action Panel-->
  <div class="cc-action-panel row">
      <!--Search with close-->
      <div class="cc-search with-close">
         <input id="kioskConfigSearchText" [(ngModel)]="searchText" type="text" class="form-control" placeholder="{{'_General_Search_Text_' | translate }}"
         (keydown.enter)="search($event)" />
         <button id="kioskConfigSearchButton" type="button" class="cc-search-btn" (click)="searchOnClick(searchText)"><span
            class="fas fa-search"></span></button>
            <button *ngIf="searchText" [ngClass]="{ 'show-btn': searchText !== '' }" class="cc-close-btn"
          (click)="onClearSearchTextClicked()">
          <span class="fas fa-times"></span>
        </button>
      </div>
      <!-- Copy Settings-->
      <div>
         <button *ngIf="(userPermissionList?.includes(32)) && (userPermissionList?.includes(33))" id="copyKioskButton" type="button" class="btn btn-primary" (click)="showHideCopyPopup()"
         [disabled]="!(kioskCreatedList.length > 0)">{{'_Kiosks_Copy_Settings_Button_Text_' | translate }}
         </button>
      </div>
  </div>

  <div #anchor class="kiosk-alert-grid-wrapper">
    <kendo-grid [kendoGridBinding]="kioskGridSource" [pageSize]="pageSize" [pageable]="true"
      [sortable]="{allowUnsort: false, mode: 'single'}" scrollable="scrollable" [sort]="sort">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="locationCode" title="{{'_General_Location_Code_Text_' | translate }}" [width]="200"
        [headerStyle]="{'font-weight' : 'bold'}"></kendo-grid-column>
      <kendo-grid-column field="locationName" title="{{'_General_Location_Name_Text_' | translate }}" [width]="230"
        [headerStyle]="{'font-weight' : 'bold'}"></kendo-grid-column>

      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell-items-center">
            <button class="cc-icon-btn" *ngIf="dataItem.kioskCreated==true" title="{{'_Kiosks_Action_Launch_Kiosk_Text_' | translate }}"><span class="fas fa-link"
                (click)="launchKiosk(dataItem.locationCode)"></span></button>
            <button class="cc-icon-btn" *ngIf="dataItem.kioskCreated==true && (userPermissionList?.includes(33))" title="{{'_General_Button_Edit_Text_' | translate }}"
              (click)="editKioskConfiguration(dataItem)"><span class="fas fa-pen"></span></button>
            <button class="cc-icon-btn" *ngIf="dataItem.kioskCreated==true && (userPermissionList?.includes(34))" title="{{'_General_Button_Delete_Text_' | translate }}"
              (click)="openDeletePopup(popUp,dataItem)"><span class="fas fa-trash-alt"></span></button>
            <button class="cc-icon-btn" *ngIf="dataItem.kioskCreated!=true && (userPermissionList?.includes(32))" title="{{'_General_Button_Add_Text_' | translate }}"
              (click)="addKioskConfiguration(dataItem)"><span class="fas fa-plus"></span></button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>

<form [formGroup]="copySettingsForm" (ngSubmit)="copyKioskConfiguration()">
  <kendo-dialog class="copy-kiosk-modal" *ngIf="showPopUp" title="{{'_Kiosks_Copy_Kiosk_Configuration_Popup_Header_Text_' | translate }}"
    (close)="closeCopySettingPopup()" [minWidth]="300" [width]="500">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="copy-from">
      <label>{{'_Kiosks_Copy_Kiosk_Configuration_Popup_Copy_From_Label_' | translate }}</label>
      <select class="cc-select-dropdown form-control" formControlName="copyFrom">
        <option value="">{{'_General_Select_Text_' | translate }}</option>
        <option *ngFor="let location of kioskCreatedList" [ngValue]="location.locationId.toString()">
          {{location.locationName}}
        </option>
      </select>
    </div>
    <div class="copy-to">
      <label>{{'_Kiosks_Copy_Kiosk_Configuration_Popup_Copy_To_Label_' | translate }}</label>
      <ng-multiselect-dropdown [ngClass]="'cc-multi-select'" name="copyTo" placeholder="{{'_General_Select_Text_' | translate }}" 
      [settings]="dropdownSettings" [data]="kioskNotCreatedList" formControlName="copyToValues" >
      </ng-multiselect-dropdown>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
      <button id="copyKioskCancelButton" type="button" class="btn btn-secondary"
        (click)="closeCopySettingPopup()">{{'_General_Button_Cancel_Text_' | translate }}</button>
      <button id="copyKioskSaveButton" type="button" class="btn btn-primary" type="submit"
        [disabled]="!copySettingsForm.valid">{{'_General_Button_Save_Text_' | translate }}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>

<app-modalpopup header="{{'_Kiosks_Delete_Kiosk_Configuration_Popup_Header_Text_' | translate }}" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}" actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate}}"
  [message]="deleteMessage" #popUp (submitted)="deleteKioskConfiguration()"
  (cancelled)="closeDeleteKioskConfigPopUp(popUp)">
</app-modalpopup>
